import { render, staticRenderFns } from "./KnOrderDetail.vue?vue&type=template&id=5bfb6863"
import script from "./KnOrderDetail.js?vue&type=script&lang=js&external"
export * from "./KnOrderDetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports